/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/
import { defineMessages } from 'react-intl';

export const ApplicationStepMessages = defineMessages({
  title: {
    id: 'Facebook.ApplicationStepMessages.title',
    defaultMessage: 'Create a Facebook application'
  },
  descriptionOne: {
    id: 'Facebook.ApplicationStepMessages.descriptionOnePartOne',
    defaultMessage:
      'Go to <link>Facebook for Developers</link> and log in with your Facebook credentials. Click <strong>Add a New App</strong> and complete the steps to create a new app ID.'
  },
  descriptionTwo: {
    id: 'Facebook.ApplicationStepMessages.descriptionTwo',
    defaultMessage:
      'Note: If you have already created the app you want to use, select it from the {myApps} menu.'
  },
  myApps: {
    id: 'Facebook.ApplicationStepMessages.myApps',
    defaultMessage: 'My Apps'
  },
  descriptionThree: {
    id: 'Facebook.ApplicationStepMessages.descriptionThree',
    defaultMessage:
      'In the navigation pane, click {settingsBasic}. Under {appSecret}, click {show}. Copy the app secret and paste it here:'
  },
  settingsBasic: {
    id: 'Facebook.ApplicationStepMessages.settingsBasic',
    defaultMessage: 'Settings -> Basic'
  },
  appSecret: {
    id: 'Facebook.ApplicationStepMessages.appSecret',
    defaultMessage: 'App Secret'
  },
  show: {
    id: 'Facebook.ApplicationStepMessages.show',
    defaultMessage: 'Show'
  },
  applicationSecretPlaceholder: {
    id: 'Facebook.ApplicationStepMessages.applicationSecretPlaceholder',
    defaultMessage: 'Enter an application secret'
  },
  applicationSecretLabel: {
    id: 'Facebook.ApplicationStepMessages.applicationSecretLabel',
    defaultMessage: 'Application secret'
  },
  nonEmptyAppSecret: {
    id: 'Facebook.ApplicationStepMessages.nonEmptyAppSecret',
    defaultMessage: 'Application secret cannot be empty'
  },
  required: {
    id: 'Facebook.ApplicationStepMessages.required',
    defaultMessage: 'Application secret is required'
  }
});
